import { render, staticRenderFns } from "./bookValue.vue?vue&type=template&id=95653458&scoped=true&"
import script from "./bookValue.vue?vue&type=script&lang=js&"
export * from "./bookValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95653458",
  null
  
)

export default component.exports